import { authService } from '@/service/auth';
export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest extends LoginRequest {
  first_name: string;
  last_name: string;
  confirmPassword: string;
}

export interface LoginResponse {
  success: boolean;
  error?: string;
  accessToken?: string;
}

export interface RegisterResponse {
  success: boolean;
  error?: string;
}


export class Auth {
  static async login(data: LoginRequest): Promise<LoginResponse> {
    try {
      return await authService.login(data);
    } catch (e: any) {
      return {
        success: false,
        error: e.response?.data?.error || 'Login failed',
      };
    }
  }

  static async register(data: RegisterRequest): Promise<RegisterResponse> {
    try {
      return await authService.register(data);
    } catch (e: any) {
      return {
        success: false,
        error: e.response?.data?.error || 'Registration failed',
      };
    }
  }
}